import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../../context/UIContext';
import { ROUTES } from '../../constants/routes';

// Tiny mounted-once helper that listens for the global `trustlab:unauthorized`
// event (fired by createAuthBaseQuery when any API call returns 401) and:
//   - shows a toast with the server's reason (e.g. "Account deactivated")
//   - redirects the user to /login so they don't see broken UI
const UnauthorizedListener = () => {
  const navigate = useNavigate();
  const { showToast } = useUI();

  useEffect(() => {
    const onUnauth = (e) => {
      const message = e?.detail?.message || 'Your session has ended. Please sign in again.';
      showToast(message);
      navigate(ROUTES.LOGIN, { replace: true });
    };
    window.addEventListener('trustlab:unauthorized', onUnauth);
    return () => window.removeEventListener('trustlab:unauthorized', onUnauth);
  }, [navigate, showToast]);

  return null;
};

export default UnauthorizedListener;
